export default "__VITE_ASSET__DpJgfUxn__"